export const userInfo = {
  uid: "wU9y7LxJMBcOHrULXasdftXDNOYCJQA2",
  email: "example@example.com.com",
  username: "example",
};
